
seedWebServices.service('PubService', ['$http', '$cacheFactory', '$uibModal', 'TranslationService', 'ToastService', '$window', '$timeout',
    function ($http, $cacheFactory, $uibModal, TranslationService, ToastService, $window, $timeout) {

        var ctrl = this;
        var serviceCache = $cacheFactory('PubService');
        var URL = '../Api/Pub/';

        this.resetCache = function () {
            serviceCache.removeAll();
        };        

        this.getEmailDocs = function (linkID) {
            return $http.get(URL + 'GetEmailDocs', {
                params: { linkID: linkID }
            });
        };

        
    }
]);